// extracted by mini-css-extract-plugin
module.exports = {"GroupChannelListProvider":"ChatNotifications_GroupChannelListProvider__hx15F"};